"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ripemd160 = ripemd160;
exports.sha256 = sha256;
exports.sha512 = sha512;

var _browser = require("../lib/browser");

async function sha256(msg) {
  const result = await (0, _browser.browserSha256)(msg);
  return result;
}

async function sha512(msg) {
  const result = await (0, _browser.browserSha512)(msg);
  return result;
}

async function ripemd160(msg) {
  throw new Error("Not supported for Browser async methods, use sync instead!");
}